import React, {Component} from "react";
import {Row, Col, Card, CardBody, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import {
  getParents,
  addParent,
  showAddParentModal,
  removeParent,
  editParent,
  resetParentQuery
} from "../../store/parent/actions";
import {connect} from "react-redux";
import ParentList from "./List/ParentList";
import AddParent from "./AddParent";
import {Space} from "antd";
import axios from "axios";
import baseURL from "../../config";
import fileDownload from "js-file-download";
import FilterTable from "../../components/FilterTableByParams/FilterTable";
import Paging from "../../components/Pagination/Pagination";
import LoadingCard from "../../components/LoadingCard/LoadingCard";
import ListSearch from "components/ListSearch/ListSearch";

class Parents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      fields: [
        {title: 'Име', key: 'name'},
        {title: 'Фамилия', key: 'surname'},
        {title: 'Имейл', key: 'email'},
        {title: 'Телефон', key: 'phone'},
        {title: 'Дата на създаване', key: 'createdAt', type: 'date'},
        {title: 'Дата на обновяване', key: 'updatedAt', type: 'date'},
        {title: 'Одобрен', key: 'approved', type: 'select',
          options:
            [{value: 'Yes', label: 'Да'},
              {value: 'No', label: 'Не'}]}],
      searchParams: {},
    }
    this.onNewParentModal = this.onNewParentModal.bind(this);
    this.onNewParentSubmit = this.onNewParentSubmit.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onApply = this.onApply.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    this.props.getParents({type: 'PARENT'});
  }

  setPage = (currentPage) => {
    this.props.getParents({ type: 'PARENT', page: currentPage });
  }

  setPageSize = (pageSize) => {
    this.props.getParents({ type: 'PARENT', pageSize, page: 1 });
  }

  onNewParentModal() {
    this.props.showAddParentModal(!this.props.isAddNewParentOpen);
  }

  onNewParentSubmit(parent) {
    this.props.addParent(parent);
  }

  onRemove(parent) {
    this.props.removeParent(parent);
  }

  onEdit(parent) {
    this.props.editParent(parent);
  }

  onCancel = (isClear=false) => {
    if (isClear) {
      this.refreshPage()
    }
    this.setState({
      open: false,
    });
  }

  onApply = (data) => {
    this.setState({
      searchParams: {...data}
    })
    this.onSearch();
  }

  onSearch = () => {
    let search = ''
    if (Object.keys(this.state.searchParams).length > 0) {
      search = Object.keys(this.state.searchParams).map(key => `${key}=${this.state.searchParams[key]}`).join(';')
    }
    this.props.getParents({ type: 'PARENT', search, page: 1 });
  }

  refreshPage = () => {
    this.setState({searchParams: {}})
    // Clearing the filter modal shouldn't also drop the free-text search.
    const { q } = this.props.query;
    this.props.resetParentQuery();
    this.props.getParents({type: 'PARENT', q: q || ''});
  }

  handleTextSearch = (q) => {
    this.props.getParents({ type: 'PARENT', q, page: 1 });
  }

  downloadUsersToExel = (e) => {
    e.preventDefault();
    const filename = new Date().toISOString() + ".xml";
    let search = ''
    if (Object.keys(this.state.searchParams).length > 0) {
      search = `?search=${Object.keys(this.state.searchParams).map(key => `${key}=${this.state.searchParams[key]}`).join(';')}`
    }
    axios
      .post(`${baseURL}/api/v2/users/export-parents${search}`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        fileDownload(res.data, filename);
        console.log(res, filename, res);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    const {open, fields, searchParams} = this.state;
    const {parentList, isLoadingAddParent, isAddNewParentOpen, loadingParents, query} = this.props;
    const { page: currentPage, pageSize, q } = query;
    
    // Extract data from the paginated response
    // ApiHelper returns response.data.data, so parentList contains { users, total, pages }
    const parents = parentList?.users || [];
    const total = parentList?.total || 0;
    const pages = parentList?.pages || 1;
    
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Breadcrumbs title="Стопани" breadcrumbItem="Стопани"/>

            <Row>
              <Col>
                {!loadingParents ? (
                  <Card>
                    <div className="list-toolbar py-2">
                      <Paging
                        setPage={this.setPage}
                        setPageSize={this.setPageSize}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        pages={pages}
                      />
                      <ListSearch
                        value={q || ""}
                        onSearch={this.handleTextSearch}
                        placeholder="Търсене по име, имейл или телефон"
                      />
                      <Space direction="horizontal" className="mr-4">
                        <Button type={'button'} className='btn btn-info waves-effect waves-light search-btn'
                                onClick={this.downloadUsersToExel}>Изтегли стопаните</Button>
                      </Space>
                      <Space direction="horizontal" className="mr-4">
                        <Button type={'button'} className='btn btn-info waves-effect waves-light search-btn'
                                onClick={() => this.setState({open: true})}><i
                          className="bx bx-filter-alt align-middle"></i></Button>
                        {(searchParams && Object.keys(searchParams).length > 0) &&
                          <Button type={'button'}
                                  className='btn btn-dark waves-effect waves-light search-btn'
                                  onClick={this.refreshPage}><i
                            className='bx bx-revision align-middle'></i></Button>}
                      </Space>
                    </div>
                    <CardBody>
                      <div className="mb-2 text-muted">
                        Общо: {total} стопани
                      </div>
                      <ParentList
                        list={{users: parents}}
                        onRemoveItem={this.onRemove}
                        onEditItem={this.onEdit}
                        history={this.props.history}
                      />
                    </CardBody>
                    <Paging 
                      setPage={this.setPage} 
                      setPageSize={this.setPageSize} 
                      pageSize={pageSize} 
                      currentPage={currentPage}
                      pages={pages}
                    />
                  </Card>
                ) : (
                  <LoadingCard />
                )}
              </Col>
            </Row>
          </div>
        </div>
        <AddParent
          isLoading={isLoadingAddParent}
          isNewParentModalOpen={isAddNewParentOpen}
          onSubmit={this.onNewParentSubmit}
          onCancel={this.onNewParentModal}
        />
        <FilterTable open={open} fields={fields} onCancel={this.onCancel} onApply={this.onApply} initialValues={searchParams}/>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {Parent} = state;
  const query = Parent.query || { page: 1, pageSize: 20, search: '' };
  return {...Parent, query};
};

export default connect(mapStatetoProps, {
  getParents,
  addParent,
  showAddParentModal,
  removeParent,
  editParent,
  resetParentQuery
})(Parents);
